const receiptDefaultState = {
    orderHistory: [],
    loading: false,
    error: false,
    filter: '',
    orderTagStatus: 0
};

export default (state = receiptDefaultState, action) => {

    switch(action.type) {
        case 'RECEIPT_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error
            }

        case 'RECEIPT_DELIVERED':
            return {
                ...state,
                loading: false
            }

        case "RECEIPT_LOADING":
            return {
                ...state,
                loading: true
            }

        case "CURRENT_TAG":
            return {
                ...state,
                orderTagStatus: action.orderTagStatus
            }

        case "RECEIPT_COMPLETE":
            return {
                ...state,
                loading: false
            }

        default:
            return state;
    }
};